import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pw8vheec39: FaireBrandEntity = {
  token: "b_pw8vheec39",
  type: "brand",
  name: "Miche Custom",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5a5029b8a4d82c17a6c64c3795f69613adaff3ce1b8efe529d1c393e657dcb6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e7ea8ffafd23c17f413cca9ab72d53445ff59a822617099fe08a92f66895d6be.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a5a5029b8a4d82c17a6c64c3795f69613adaff3ce1b8efe529d1c393e657dcb6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e7ea8ffafd23c17f413cca9ab72d53445ff59a822617099fe08a92f66895d6be.png",
  location: "Muskego, WI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "Clothing That Creates Memories™. Make moments special with custom photo-ready clothing that can be worn for years to come!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.184Z",
    importedBy: "entity-db-cli",
  },
};
